import { Component, OnInit, ViewChild } from '@angular/core';
import { AcuerdoPagoService } from '../../services/acuerdo-pago.service';
import { PaginationComponent } from '../../components/pagination/pagination.component';

@Component({
  selector: 'app-acuerdos',
  templateUrl: './acuerdos.component.html',
  styleUrls: ['./acuerdos.component.scss']
})
export class AcuerdosComponent implements OnInit {

  headersAcuerdoPago:any[]=[]
  listAcuerdoPagoPorAprobar:any[]=[]
  showModalAprobacion:boolean=false
  paginationAcuerdos:any={
    hasNextPage:false,
    hasPrevPage:false,
    totalPages:[],
    page:0
  }

  @ViewChild("paginationAcuerdos",{static:false}) paginadorAcuerdos:PaginationComponent;

  constructor(
    private acuerdoPagoService:AcuerdoPagoService
  ) { 
    this.headersAcuerdoPago=[
      {
        label: "Cliente",
        key: "_id",
        subKey:"cliente",
        customClass: "acuerdos",
        type:"data-cuenta-acuerdo"
      },
      {
        label: "Nro Documento",
        key: "_id",
        subKey:"nro_documento",
        customClass: "acuerdos",
        type:"data-cuenta-acuerdo"
      },
      {
        label: "Operacion/Cuenta",
        key: "_id",
        subKey:"cuenta",
        customClass: "acuerdos",
        type:"data-cuenta-acuerdo"
      },
      {
        label: "Fecha Acuerdo",
        key: "_id",
        subKey:"fecha_acuerdo",
        customClass: "acuerdos",
        type:"data-cuenta-acuerdo"
      },
      {
        label: "Cuotas",
        key: "cuotas",
        subKey:"",
        customClass: "acuerdos",
        type:""
      },

      {
        label: "Monto Acuerdo",
        key: "total",
        subKey:"$numberDecimal",
        customClass: "acuerdos",
        type:"money"
      },
      {
        label: "",
        key: "_id",
        subKey:"",
        customClass: "acuerdos",
        type:"buttonDelete"
      }

    ]
  }

  ngOnInit() {
    this.acuerdoPagoService.getListaAcuerdoPago("").subscribe((data:any)=>{
      let perfil:string=sessionStorage.getItem("perfil")

      

      this.listAcuerdoPagoPorAprobar=data.acuerdos_pago.docs
      this.paginationAcuerdos.hasNextPage=data.acuerdos_pago.hasNextPage
      this.paginationAcuerdos.hasPrevPage=data.acuerdos_pago.hasPrevPage
      this.paginationAcuerdos.totalPages=new Array(data.acuerdos_pago.totalPages)
      this.paginationAcuerdos.page=data.acuerdos_pago.page
      this.paginadorAcuerdos.pagParams=this.paginationAcuerdos
    })
  }

  filterGrid(filter:any){
    let filterQuery:string=""
    if(filter.target.id=="nro_documento"){
      filterQuery="nro_documento="+filter.target.value
    }

    if(filter.target.id=="nombre_cliente"){
      filterQuery="cliente="+filter.target.value
    }
    
    this.acuerdoPagoService.getListaAcuerdoPago("page=1&"+filterQuery).subscribe((data:any)=>{
      this.listAcuerdoPagoPorAprobar=data.acuerdos_pago.docs
      this.paginationAcuerdos.hasNextPage=data.acuerdos_pago.hasNextPage
      this.paginationAcuerdos.hasPrevPage=data.acuerdos_pago.hasPrevPage
      this.paginationAcuerdos.totalPages=new Array(data.acuerdos_pago.totalPages)
      this.paginationAcuerdos.page=data.acuerdos_pago.page
      this.paginadorAcuerdos.pagParams=this.paginationAcuerdos
    })

   
  }

  refreshPageAcuerdos(page:any){
    
    this.acuerdoPagoService.getListaAcuerdoPago("page="+page).subscribe((data:any)=>{
      let perfil:string=sessionStorage.getItem("perfil")

      this.listAcuerdoPagoPorAprobar=data.acuerdos_pago.docs
      this.paginationAcuerdos.hasNextPage=data.acuerdos_pago.hasNextPage
      this.paginationAcuerdos.hasPrevPage=data.acuerdos_pago.hasPrevPage
      this.paginationAcuerdos.totalPages=new Array(data.acuerdos_pago.totalPages)
      this.paginationAcuerdos.page=data.acuerdos_pago.page
      this.paginadorAcuerdos.pagParams=this.paginationAcuerdos
    })
  }

  datoParaAprobar:any=""
  aprobarAP(acuerdo:any){
    this.datoParaAprobar=acuerdo
    this.showModalAprobacion=true
  }

  acuerdoTemp:any
  deleteAcuerdo(acuerdo:any){
    this.showModalAprobacion=true
    this.acuerdoTemp=acuerdo
  }

  confirmarEliminarAcuerdo(){

    let dataSend:any={
      cuenta:this.acuerdoTemp.cuenta,
      nro_documento:this.acuerdoTemp.nro_documento,
      fecha_acuerdo:this.acuerdoTemp.fecha_acuerdo
    }


    this.acuerdoPagoService.deleteAcuerdoPago(dataSend).subscribe((data:any)=>{
      this.refreshPageAcuerdos(1)
      this.closeModal()
    })
    this.closeModal()
  }

  getFecActual(){
    let hoy = new Date();
    let i=0;
    let fecha = hoy.getDate()+ '/' + ((hoy.getMonth())+1) + '/' + hoy.getFullYear();
    let mes:any=((hoy.getMonth())+1);
    mes=(mes.toString().length==1)?"0"+mes:mes;
    let dia:any=hoy.getDate();
    dia=(dia.toString().length==1)?"0"+dia:dia;
    return hoy.getFullYear()+"-"+mes+"-"+dia
  }

  closeModal(){
    this.datoParaAprobar=""
    this.showModalAprobacion=false
  }
}
